module.exports = __webpack_public_path__ + "img/shape-13.b0abb295.svg";